import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';


const swiper = new Swiper('.swiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  autoplay: false,
  spaceBetween:0,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }

  // Navigation arrows

  // And if we need scrollbar

});
const swiperparceiros = new Swiper('.swiper-parceiros', {
  direction: 'horizontal',
  loop: true,
  spaceBetween: 70, // Espaço entre os slides padrão (desktop)
  navigation: {
    nextEl: '.swiper-button-nextseta',
    prevEl: '.swiper-button-prevseta',
  },
  slidesPerView: 4, // Padrão: 4 slides por vista (desktop)

  // --- Breakpoints para responsividade ---
  breakpoints: {
   
    0: { 
      slidesPerView: 1,
      spaceBetween: 20, 
    },
  
    1024: {
      slidesPerView: 4,
      spaceBetween: 70,
    }
  }
});

const swiperpoliticaedesenvolvimento = new Swiper('.swiper-politica-e-desenvolvimento', {
  direction: 'horizontal',
  loop: false,
  autoplay: false, // Isso está configurado corretamente como false
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 4,
  spaceBetween: 40, 
  on: {
    init: function () {
      console.log('Swiper inicializado:', this);
      
    }
  }
});
swiper;
swiperparceiros;
swiperpoliticaedesenvolvimento;